<div
  class="card"
  [class.best-value-card-background]="isBestValue"
  [class]="isBestValue ? activePlatformGroup + '-border' : ''"
>
  <section class="card-details">
    <span class="product-title title-xs">{{ product.name | translate }}</span>
    @if (calendarFeature) {
      <ui-product-calendar-label
        [productCode]="product.code"
        [title]="calendarFeature.translation"
      />
    }
  </section>
  <span class="product-price title-xs">
    <span class="nobold">{{ product.currency }} </span>
    {{ product.basePrice / 100 | currency: ' ' : 'code' : '1.0-0' : 'fr-CH' }}
  </span>
  @if (!isReadMode) {
    <ui-button
      class="select-btn"
      mkpDataTest="select-cta-sticky-header-btn"
      [loading]="isLoading"
      [config]="selectConfig"
      (click)="handleSelectedProduct.emit(product.code)"
    >
      {{ 'PRODUCT_OFFERING.SELECT_PLAN' | translate }}
    </ui-button>
  }
</div>
